/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import ThaliaAbstractBasicLayout from './ThaliaAbstractBasicLayout';

export default class ThaliaGeneralNegative extends ThaliaAbstractBasicLayout {
	get key() {
		return 'thalia_basic BannerLayout--thalia_general btn--negative';
	}
}
